import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Loader2 } from 'lucide-react';

import { logout } from '@/store/actions/creators/authActions';
import { AuthLayout } from '@/components/auth/AuthLayout';

export default function Logout() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    (async () => {
      // @ts-expect-error legacy redux-thunk action types
      await dispatch(logout());
      navigate('/');
    })();
  }, []);

  return (
    <AuthLayout bare>
      <div className="flex flex-col items-center gap-3 py-12">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
        <p className="text-sm text-muted-foreground">Signing out...</p>
      </div>
    </AuthLayout>
  );
}
